import increaseOpacity from '../../common/utils/increase-opacity';
import primaryButtonDisabled from '../../common/algorithms/primary-button-disabled';

const INITIAL_OPACITY = 0;

const disabledEmphasis = (params) => {
  const { targetColor, backgroundColor, surfaceColor } = params;

  const calculatedColor = increaseOpacity({
    targetColor,
    backgroundColor,
    surfaceColor,
    opacity: INITIAL_OPACITY,
    condition: (ratio) => ratio >= 2,
    fallback: {
      rule: 'text.disabledEmphasis',
      params,
    },
  });

  if (calculatedColor.alpha === 1) {
    return primaryButtonDisabled({
      targetColor,
      backgroundColor,
    });
  }

  return calculatedColor;
};

export default disabledEmphasis;
